import { useModalContext, ModalType } from '../../../contexts/ModalContext';
import { Filter24 } from 'ui/icons/aurora/24px/Filter24';
import { Button, BUTTON_VARIANTS } from 'ui/button';
import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { DASHBOARD_FILTER_TRIGGER_ID, DashboardFilterTagGroup } from './DashboardFilterTagGroup';

export const DashboardFilter = () => {
  const { openModal, closeModal } = useModalContext();
  const { selectedFiltersCount = 0 } = useMissionControlContext();

  const hasFilters = selectedFiltersCount > 0;

  const openFiltersModal = () =>
    openModal(ModalType.DashboardFiltersModal, {
      onClose: () => closeModal(ModalType.DashboardFiltersModal),
    });

  if (!hasFilters)
    return (
      <Button
        onClick={openFiltersModal}
        data-test={DASHBOARD_FILTER_TRIGGER_ID}
        variant={BUTTON_VARIANTS.GHOST}
      >
        <Filter24 /> Apply filter
      </Button>
    );

  return <DashboardFilterTagGroup openFiltersModal={openFiltersModal} />;
};
